import { ObjectReferenceHoverCard } from '@heidi/agents';
import { composerTokenToRef, type ChatObjectTokenAttrs } from '@heidi/agents/data';
import type { ReactElement } from 'react';

import { ResolveReference } from './chat-object-reference';

/** Gives a composer token the same hover card its sent chip gets. */
export const ChatObjectTokenHoverCard = ({
  attrs,
  children,
}: {
  attrs: ChatObjectTokenAttrs;
  children: ReactElement;
}): ReactElement => {
  const target = composerTokenToRef(attrs);
  if (!target) return children;
  return (
    <ResolveReference target={target}>
      {(ref) =>
        ref.summary ? (
          <ObjectReferenceHoverCard object={ref.summary}>
            {children}
          </ObjectReferenceHoverCard>
        ) : (
          children
        )
      }
    </ResolveReference>
  );
};
